import { Alert, Box, Button, Container, FormControl, InputLabel, LinearProgress, MenuItem, Select, Skeleton, Snackbar, Stack, Table, TableBody, TableContainer, TableHead, TableRow, TextField, Typography } from '@mui/material'
import Paper from '@mui/material/Paper';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import { styled } from '@mui/material/styles';
import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import AddIcon from '@mui/icons-material/Add';
import PrintIcon from '@mui/icons-material/Print';
import DeleteIcon from '@mui/icons-material/Delete';

import { ajout,getvendeurs,showmodal,getList,remove } from "./versementsSlice";
import axios from 'axios';
import Ajouter from './Ajouter';
import { imprimerBonVersement } from './imprimerBonVersement';

export default function Versements() {

    const StyledTableCell = styled(TableCell)(({ theme }) => ({
        [`&.${tableCellClasses.head}`]: {
          backgroundColor: theme.palette.common.black,
          color: theme.palette.common.white,
        },
        [`&.${tableCellClasses.body}`]: {
          fontSize: 14,
        },
      }));
      
      const StyledTableRow = styled(TableRow)(({ theme }) => ({
        '&:nth-of-type(odd)': {
          backgroundColor: theme.palette.action.hover,
        },
        // hide last border
        '&:last-child td, &:last-child th': {
          border: 0,
        },
      }));

      
    const [Chargement, setChargement] = useState(false);
    const [Progession, setProgession] = useState(false);
    const [valVendeurs, setvalVendeurs] = useState('Tout');
    const [removeSuccess, setRemoveSuccess] = useState(false);

    const VersementData = useSelector(state => state.versementsData);
    const ListVendeur = VersementData.listVendeurs;
    const listVersements=VersementData.list;
    const ajoutSuccess = VersementData.ajoutOk;

    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    const todayDate = `${year}-${month}-${day}`;
  
    const [selectedDate, setSelectedDate] = useState(todayDate);

    const dateField=useRef('')

    const handleDateChange = (event) => {
      setSelectedDate(event.target.value);
    };

    const handleVendeurChange = (event) => {
        setvalVendeurs(event.target.value);
      };

      const formatDate = (dateString) => {
        const [date] = dateString.split('T');
        return `${date}`;      
      };

      const formatDateToFrench = (dateString) => {
        const [date] = dateString.split('T');
        const [year, month, day] = date.split('-');
        return `${day}/${month}/${year}`;
      };

      const navigate = useNavigate();
      const dispatch= useDispatch();

      const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
          return;
        }
        dispatch(ajout(false));
        setRemoveSuccess(false);
      };

    const userData = useSelector(state => state.userData)
    const id = userData.id;
    const apitoken = userData.apitoken;
    const typeCompte = userData.type
    const apiUrl = process.env.REACT_APP_API_URL;

    const Imprimer = async (idversement) => {
      try {
        await imprimerBonVersement(apiUrl, id, apitoken, idversement);
      } catch (error) {
        window.alert(error.message || 'Impossible d’ouvrir le bon de versement.');
      }
    };

      const suppression = async (idversement)=> {
        setProgession(true);

        try {
            const response = await axios.post(`${apiUrl}delete/versement/${id}/${apitoken}/${idversement}`);
            if(response.data.status==="ok")
                {
                    dispatch(remove(idversement));
                    setRemoveSuccess(true);
                    setProgession(false);
                }
        } catch (error) {
          navigate('/');
        }
    }
      const supprimer = (id,nom) => {
        let result = window.confirm(`Supprimer ce versement de ${nom} ?`);
        if (result === true) {
            suppression(id);
        }
      }

    const dh = (value) => `${Number(value ?? 0).toLocaleString('fr-FR', {minimumFractionDigits: 2, maximumFractionDigits: 2})} DH`;

    function ShowList() {
        if(listVersements.length > 0){
          let listFiltre=listVersements.filter(item => formatDate(item.date) === selectedDate)
        
          if(valVendeurs!=="Tout") {
            listFiltre = listFiltre.filter(cloture => cloture.vendeur["id"] === valVendeurs)
        }
          return listFiltre.map(Clotures => {
            return(
              <StyledTableRow key={Clotures._id}>
              <StyledTableCell component="th" scope="row">
                {Clotures.vendeur.nom}
              </StyledTableCell>
      
              <StyledTableCell>{Clotures.ca == null ? '—' : dh(Clotures.ca)}</StyledTableCell>
              <StyledTableCell>{dh(Clotures.creditDonne)}</StyledTableCell>
              <StyledTableCell>{dh(Clotures.creditEncaisse)}</StyledTableCell>
              <StyledTableCell>{dh(Clotures.espece)}</StyledTableCell>
              <StyledTableCell>{dh(Clotures.cheque)}</StyledTableCell>
              <StyledTableCell>{dh(Clotures.banque)}</StyledTableCell>
              <StyledTableCell>{Clotures.total_verse == null ? '—' : dh(Clotures.total_verse)}</StyledTableCell>
              <StyledTableCell>{Clotures.manque == null ? '—' : dh(Clotures.manque)}</StyledTableCell>

              <StyledTableCell component="th" scope="row">
              {Clotures.date!=="" ? formatDateToFrench(Clotures.date) : ''}
              </StyledTableCell>
              <StyledTableCell align="right">
              {<Button sx={{ marginLeft: '10px',width:'140px' }} variant="outlined" color='primary' startIcon={<PrintIcon />} onClick={() => Imprimer(Clotures._id)} >
              Imprimer
              </Button>}  
              { typeCompte === "admin" ? 
              <Button sx={{ marginLeft: '10px',width:'140px' }} variant="outlined" color='error' startIcon={<DeleteIcon />} onClick={() => supprimer(Clotures._id,Clotures.vendeur.nom)}>
               Supprimer
              </Button>
                      :
                      ""
                  }


              {typeCompte === "manager" && formatDate(Clotures.date) === todayDate && (
                <Button
                  sx={{ marginLeft: '10px', width: '140px' }}
                  variant="outlined"
                  color="error"
                  startIcon={<DeleteIcon />}
                  onClick={() => supprimer(Clotures._id, Clotures.vendeur.nom)}
                >
                  Supprimer
                </Button>
              )}

              </StyledTableCell>
            </StyledTableRow>
            )
      
          })
          }
          else {
            return (
              <StyledTableRow>
              <StyledTableCell align='center' colSpan={13} component="th" scope="row">
              Pas de données
              </StyledTableCell>
            </StyledTableRow>
            )
          }
          }

    const getVendeurs=async () => {
        try {
        const response = await axios.post(`${apiUrl}vendeurs/${id}/${apitoken}`,
          {
            timeout: 20000,
          }
        );
        dispatch(getvendeurs(response.data));
        }
     catch (error) {
      navigate('/');    
    }
    }

      const getVersements = async (dateToLoad = selectedDate) => {
        setChargement(true);
        try {
          const response = await axios.post(
            `${apiUrl}versements/${id}/${apitoken}/${dateToLoad}/${dateToLoad}`,
            {}, { timeout: 20000 }
          );
          dispatch(getList(response.data));
        } catch (error) {
          console.error('Erreur chargement versements', error);
        } finally {
          setChargement(false);
        }
      };

      useEffect(() => {
        getVendeurs();
        dispatch(showmodal(false));
      }, []);

      useEffect(() => {
        getVersements(selectedDate);
      }, [selectedDate]);

  return (
    <Container maxWidth="lg" sx={{ marginTop: '40px' }}>
        
        <Typography variant="h4" align='center' color="primary">
        Liste des versements
        </Typography>
        <Box display="flex" width="100%" mt={5}>
        <Box>
{Chargement ? 
        <Skeleton sx={{ marginTop: '20px' }}  variant="rounded" height={56} width={150} />
         :
<FormControl sx={{ minWidth: 150 }}>
          <InputLabel id="demo-simple-select-label">Vendeurs</InputLabel>
          <Select
        
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={valVendeurs}
          label="Vendeurs"
          onChange={handleVendeurChange}
        >
          <MenuItem value='Tout'>Tout</MenuItem>
          {ListVendeur.map((item) => (
         <MenuItem key={item._id} value={item._id}>
           {item.nom}
         </MenuItem>
       ))}
          </Select>
          </FormControl>
}
</Box>
<Box>
{Chargement ? 
        <Skeleton sx={{ marginTop: '20px',marginLeft:'20px' }} variant="rounded" height={56} width={150} />
         :
         <TextField sx={{ marginLeft: 2 }}
         inputRef={dateField}
         value={selectedDate}
         onChange={handleDateChange}
         id="input-with-icon-textfield"
         label="Date"
         size='normal'
         type='date'
     variant="outlined"
   />  
}
</Box>

            <Box style={{ marginLeft: 'auto' }}>

               {Chargement ? 
        <Skeleton sx={{ marginTop: '20px' }}  variant="rounded" height={56} width={241} />
         :

        <Button variant="contained" size='large' color="primary" startIcon={<AddIcon/>} onClick={() =>dispatch(showmodal(true))} >
    Nouveau versement
  </Button>  
} 
</Box>

            </Box>
        {Chargement ? 
        <Skeleton sx={{ marginTop: '20px' }}  variant="rounded" height={200} />
         :
         <>
        <TableContainer sx={{ marginTop: '20px' }} component={Paper}>
          
          { Progession ?
    <Box >
  <Stack sx={{ width: '100%', color: 'grey.500' }} spacing={2}>
        <LinearProgress color="success" />
      </Stack>
    </Box>
            :
            ''
            }
      <Table sx={{ minWidth: 1700 }} aria-label="customized table">
        <TableHead>
          <TableRow>
            <StyledTableCell>Vendeur</StyledTableCell>
            <StyledTableCell>CA encaissé</StyledTableCell>
            <StyledTableCell>Crédits donnés</StyledTableCell>
            <StyledTableCell>Crédits encaissés</StyledTableCell>
            <StyledTableCell>Espèces</StyledTableCell>
            <StyledTableCell>Chèques</StyledTableCell>
            <StyledTableCell>Banque</StyledTableCell>
            <StyledTableCell>Total versé</StyledTableCell>
            <StyledTableCell>Manque</StyledTableCell>
            <StyledTableCell>Date</StyledTableCell>
            <StyledTableCell align="right">Actions</StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <ShowList/>
        </TableBody>
      </Table>
    </TableContainer>
    <Snackbar open={ajoutSuccess} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} autoHideDuration={5000} onClose={handleClose}>
        <Alert
          onClose={handleClose}
          severity="success"
          variant="filled"
          sx={{ width: '100%' }}
        >
          Versement ajouté avec succès
        </Alert>
      </Snackbar>

      <Snackbar open={removeSuccess} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} autoHideDuration={5000} onClose={handleClose}>
        <Alert
          onClose={handleClose}
          severity="success"
          variant="filled"
          sx={{ width: '100%' }}
        >
          Versement supprimé avec succès
        </Alert>
      </Snackbar>
    </>
}
<Ajouter initialDate={selectedDate} onSaved={(date) => { setSelectedDate(date); getVersements(date); }} />
    </Container>
  )
}
